import React from "react";
import styles from "./Leaderboard.module.css"; // Import CSS module
import teamData from "./teamData";

const Leaderboard = () => {
  return (
    <div className={styles.teamSection}>
      <div className={styles.overlay}> {/* Overlay to ensure visibility */}
        <div className={styles.container}>
          {/* Heading */}
          <div className={styles.header}>
            <br />
            <br />
            <br />
            <h2 className={styles.title}>
              Our Teams Database<span className={styles.highlight}></span>
            </h2>
            <p className={styles.subtitle}>
              Meet our amazing team of professionals who bring creativity and expertise.
            </p>
          </div>

          {/* Team Cards */}
          <div className={styles.teamGrid}>
            {teamData.map((member, index) => (
              <div key={index} className={styles.card}>
                {/* Image */}
                <img src={member.img} alt={member.name} className={styles.image} />

                {/* Card Content */}
                <div className={styles.cardContent}>
                  <h3 className={styles.name}>{member.name}</h3>
                  <p className={styles.role}>{member.role}</p>
                  <p className={styles.description}>{member.description}</p>

                  {/* Social Icons */}
                  <div className={styles.socialIcons}>
                    {member.social.map((icon, idx) => (
                      <a key={idx} href="#" className={styles.icon}>
                        <i className={`fab ${icon}`}></i>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Web Development Team Section */}
          <div className={styles.webDevSection}>
            <h2 className={styles.webDevTitle}>Web Development Team</h2>
            <div className={styles.teamGrid}>
              {[
                {
                  img: "https://i.ibb.co/201kD85P/Whats-App-Image-2025-02-11-at-00-08-51-8ea7c6a0.jpg",
                  name: "Yash Devkate",
                  role: "Development Team",
                  description: "Have fun in tekno!",
                  social: ["fa-github", "fa-twitter", "fa-linkedin"],
                },
                {
                  img: "https://i.ibb.co/qMGhhSrp/IMG-20240115-WA0008.jpg",
                  name: "Ritesh Chaudhari",
                  role: "Development Team",
                  description: "Enjoyy the fest!",
                  social: ["fa-github", "fa-twitter", "fa-linkedin"],
                },
              ].map((member, index) => (
                <div key={index} className={styles.card}>
                  {/* Image */}
                  <img src={member.img} alt={member.name} className={styles.image} />

                  {/* Card Content */}
                  <div className={styles.cardContent}>
                    <h3 className={styles.name}>{member.name}</h3>
                    <p className={styles.role}>{member.role}</p>
                    <p className={styles.description}>{member.description}</p>

                    {/* Social Icons */}
                    <div className={styles.socialIcons}>
                      {member.social.map((icon, idx) => (
                        <a key={idx} href="#" className={styles.icon}>
                          <i className={`fab ${icon}`}></i>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
